import React, { Component } from "react";

import "react-datepicker/dist/react-datepicker.css";
import API from "../../apiService.js";
import ALERT from "../component/Alert";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
const SignupSchema = Yup.object().shape({
  rps: Yup.string()
    .required("Harus diisi minimal 10 karakter")
    .min(10, "minimal 10 karakter"),
  anamnese: Yup.string()
    .required("Harus diisi minimal 10 karakter")
    .min(10, "minimal 10 karakter"),
});

export class Subjektif extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anamnese: props.patient.anamneses[0]
        ? props.patient.anamneses[0].anamnese
        : "",
      eval: props.patient.anamneses[0] ? props.patient.anamneses[0].eval : "",
      id: props.patient.anamneses[0] ? props.patient.anamneses[0].id : "",
      nursing_anamnese: props.patient.anamneses[0]
        ? props.patient.anamneses[0].nursing_anamnese
        : "",
      treat: props.patient.anamneses[0] ? props.patient.anamneses[0].treat : "",
      visit_id: props.patient.anamneses[0]
        ? props.patient.anamneses[0].visit_id
        : props.patient.id,
      visit_inpatient_detail_id: props.patient.anamneses[0]
        ? props.patient.anamneses[0].visit_inpatient_detail_id
        : "0",
      rekonsiliasi_obat: props.patient.anamneses[0]
        ? typeof props.patient.anamneses[0].rekonsiliasi_obat == "string"
          ? JSON.parse(props.patient.anamneses[0].rekonsiliasi_obat)
          : [
              {
                name: "",
                signa1: "",
                signa2: "",
                status: "",
              },
            ]
        : [
            {
              name: "",
              signa1: "",
              signa2: "",
              status: "",
            },
          ],
      kajian: null,
      alo_auto: "Autoanamnesis",
      responden: "",
      rps: props.patient.anamneses[0] ? props.patient.anamneses[0].rps : "",
      pregnant_status: props.patient.anamneses[0]
        ? props.patient.anamneses[0].pregnant_status
        : "-",
    };
    this.fetchKajian = this.fetchKajian.bind(this);
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.patient.anamneses[0] !== prevProps.patient.anamneses[0]) {
      this.setState({
        anamnese: this.props.patient.anamneses[0]
          ? this.props.patient.anamneses[0].anamnese
          : "",
        eval: this.props.patient.anamneses[0]
          ? this.props.patient.anamneses[0].eval
          : "0",
        id: this.props.patient.anamneses[0]
          ? this.props.patient.anamneses[0].id
          : "",
        nursing_anamnese: this.props.patient.anamneses[0]
          ? this.props.patient.anamneses[0].nursing_anamnese
          : "",
        treat: this.props.patient.anamneses[0]
          ? this.props.patient.anamneses[0].treat
          : "",
        visit_id: this.props.patient.anamneses[0]
          ? this.props.patient.anamneses[0].visit_id
          : this.props.patient.id,
        visit_inpatient_detail_id: this.props.patient.anamneses[0]
          ? this.props.patient.anamneses[0].visit_inpatient_detail_id
          : "0",
        rekonsiliasi_obat: this.props.patient.anamneses[0]
          ? typeof this.props.patient.anamneses[0].rekonsiliasi_obat == "string"
            ? JSON.parse(this.props.patient.anamneses[0].rekonsiliasi_obat)
            : [
                {
                  name: "",
                  signa1: "",
                  signa2: "",
                  status: "",
                },
              ]
          : [
              {
                name: "",
                signa1: "",
                signa2: "",
                status: "",
              },
            ],
        alo_auto: this.props.patient.anamneses[0]
          ? this.props.patient.anamneses[0].alo_auto
          : "",
        responden: this.props.patient.anamneses[0]
          ? this.props.patient.anamneses[0].responden
          : "",
        rps: this.props.patient.anamneses[0]
          ? this.props.patient.anamneses[0].rps
          : "",
      });
    }
  }

  handleTextChange = (e) => {
    let anamneses = [];
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        anamneses = { data: [this.state], param: "anamneses" };
        // console.log(this.state);
        this.props.parentCallback(anamneses);
      }
    );
  };
  handleSubmit = (e) => {
    this.checkPendaftaranBpjs();
    if (this.state.id > 0) {
      this.PutData();
    } else {
      this.PostData();
    }
    this.props.nextTab();
  };
  PostData = async () => {
    var param = {
      ...this.state,
      rekonsiliasi_obat: JSON.stringify(this.state.rekonsiliasi_obat),
    };
    const res = await API.post("management/anamneses/create", param);
    // console.log(res);
    if (res.code === 200) {
      ALERT("success", "Berhasil Menyimpan Data ");
    } else {
      ALERT("error", "gagal menyimpan data");
    }
  };

  PutData = async () => {
    var param = {
      ...this.state,
      rekonsiliasi_obat: JSON.stringify(this.state.rekonsiliasi_obat),
    };
    const res = await API.put("management/anamneses/update", param);
    if (res.code === 200) {
      ALERT("success", "Berhasil Menyimpan Data ");
    } else {
      ALERT("error", "gagal menyimpan data");
    }
  };

  checkPendaftaranBpjs = async () => {
    if (
      this.props.patient.payments?.bpjs_status == 1 &&
      this.props.patient.pcare_queue_number == null
    ) {
      const bridgingResult = await API.post(
        `/pcare/pendaftaran/${this.props.patient.id}`
      );
    }
  };
  onReload = () => {
    this.props.history.push("/pelayanan");
  };

  fetchKajian = async () => {
    // let res = await apiService.get(`management/kajian_awal/result/1378/umum`);
    let res = await API.get(
      `management/kajian_awal/result_patient/${this.props.patient.id}/dokter`
    );
    if (res) {
      let x = res.data.find((e) => e.name == "ANAMNESIS (S)");
      this.setState({ kajian: x });
    }
  };

  componentDidMount() {
    this.props.getData?.();
    this.fetchKajian();
  }

  onchangeRekonsilisasi = (idx, e) => {
    let name = e.target.name;
    let val = e.target.value;
    let st = this.state.rekonsiliasi_obat;
    st[idx][name] = val;
    this.setState({
      rekonsiliasi_obat: st,
    });
  };

  render() {
    // console.log(this.props.patient.clinics.id, this.props.patient.clinics);
    return (
      <>
        <Formik
          enableReinitialize
          initialValues={{
            anamnese: this.state.anamnese,
            rps: this.state.rps,
          }}
          validationSchema={SignupSchema}
          onSubmit={(values) => {
            this.handleSubmit();
            // same shape as initial values
            // console.log(values);
          }}
        >
          {({ values, errors, touched }) => (
            <Form>
              <div className="form-group row">
                <label
                  htmlFor="example-text-input"
                  className="col-md-5 col-form-label col-form-label-sm"
                >
                  Cek Status Hamil Pasien
                </label>
                <div className="col-md-7">
                  <div className="row">
                    <select
                      className="form-control form-control-sm col-md-6"
                      name="pregnant_status"
                      onChange={this.handleTextChange}
                      value={this.state?.pregnant_status}
                    >
                      <option value="-">Tidak</option>
                      <option value="Hamil">Hamil</option>
                      <option value="K1">K1</option>
                      <option value="K2">K2</option>
                      <option value="K3">K3</option>
                      <option value="K4">K4</option>
                      <option value="K5">K5</option>
                      <option value="K6">K6</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="example-text-input"
                  className="col-md-5 col-form-label col-form-label-sm"
                >
                  Alloanamnesis / Autoanamnesis
                </label>
                <div className="col-md-7">
                  <div className="row">
                    <select
                      className="form-control form-control-sm col-md-6"
                      name="alo_auto"
                      onChange={this.handleTextChange}
                      value={this.state.alo_auto}
                    >
                      <option value="Alloanamnesis">Alloanamnesis</option>
                      <option value="Autoanamnesis">Autoanamnesis</option>
                    </select>
                  </div>
                </div>
              </div>
              {this.state.alo_auto == "Alloanamnesis" ? (
                <div className="form-group row">
                  <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                  >
                    yang diwawancarai
                  </label>
                  <div className="col-md-7">
                    <div className="row">
                      <input
                        className="form-control form-control-sm col-md-6"
                        name="responden"
                        onChange={this.handleTextChange}
                        value={this.state.responden}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
              <div className="form-group row">
                <label
                  htmlFor="example-text-input"
                  className="col-md-5 col-form-label col-form-label-sm"
                >
                  Anamnese Keperawatan
                </label>
                <div className="col-md-7">
                  <div className="row">
                    <textarea
                      className="form-control form-control-sm"
                      type="text"
                      placeholder="Keluhan Pasien"
                      value={this.state.nursing_anamnese}
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="example-text-input"
                  className="col-md-5 col-form-label col-form-label-sm"
                >
                  Keluhan Utama <span className="text-danger">*</span>
                </label>
                <div className="col-md-7">
                  <div className="row">
                    <textarea
                      className="form-control form-control-sm"
                      type="text"
                      placeholder="Keluhan Pasien"
                      name="anamnese"
                      onChange={this.handleTextChange}
                      value={this.state.anamnese}
                      required
                    />
                    {errors.anamnese && touched.anamnese ? (
                      <div style={{ color: "red" }}>
                        &nbsp; {errors.anamnese}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="example-text-input"
                  className="col-md-5 col-form-label col-form-label-sm"
                >
                  Riwayat Penyakit Sekarang{" "}
                  <span className="text-danger">*</span>
                </label>
                <div className="col-md-7">
                  <div className="row">
                    <textarea
                      className="form-control form-control-sm"
                      type="text"
                      placeholder="RIWAYAT PENYAKIT SEKARANG"
                      name="rps"
                      onChange={this.handleTextChange}
                      value={this.state.rps}
                      required
                    />
                    {errors.rps && touched.rps ? (
                      <div style={{ color: "red" }}>&nbsp; {errors.rps}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="form-group">
                <h4>Riwayat Penyakit (Sesuai Kajian Awal)</h4>
                <div className="col-md-12">
                  <div className="row">
                    <table className="table align-items-center table-flush table-responsive">
                      <thead className="thead-light">
                        <tr>
                          {this.state.kajian?.ref_kajian?.map((a, k) => {
                            if (k > 0) {
                              return (
                                <th key={`key-${a.id}`}>{a.list[0]?.label}</th>
                              );
                            }
                          })}
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          {this.state.kajian?.ref_kajian?.map((a, k) => {
                            if (k > 0) {
                              return (
                                <td key={`value-${a.id}`}>
                                  {a.list[0]?.result?.result}
                                </td>
                              );
                            }
                          })}
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              {/* { */}
              {/* // this.props.patient.clinics.id == 1 || this.props.patient.clinics.id == 2 || this.props.patient.clinics.parent_id == 5 ? */}
              <>
                <div>
                  <h4>Obat Yang dikonsumsi (rekonsiliasi obat)</h4>
                </div>
                {this.state.rekonsiliasi_obat?.map((a, b) => (
                  <div className="form-group row" key={`rekon-${b}`}>
                    <label
                      htmlFor="example-text-input"
                      className="col-md-5 col-form-label col-form-label-sm"
                    >
                      {b == 0 ? "Pemakaian Obat" : ""}
                    </label>
                    <div className="col-md-7">
                      <div className="row">
                        {b > 0 ? (
                          <button
                            className="btn btn-sm btn-danger col-md-1"
                            onClick={() =>
                              this.setState({
                                rekonsiliasi_obat:
                                  this.state.rekonsiliasi_obat.filter(
                                    (a, idx) => idx != b
                                  ),
                              })
                            }
                          >
                            -
                          </button>
                        ) : (
                          <div className="col-md-1"></div>
                        )}
                        <input
                          name="name"
                          className="form-control form-control-sm col-md-6"
                          type="text"
                          placeholder="nama obat"
                          value={this.state.rekonsiliasi_obat[b]?.name}
                          onChange={(e) => this.onchangeRekonsilisasi(b, e)}
                        />
                        <input
                          name="signa1"
                          className="form-control form-control-sm col-md-1"
                          type="text"
                          placeholder="signa 1"
                          value={this.state.rekonsiliasi_obat[b]?.signa1}
                          onChange={(e) => this.onchangeRekonsilisasi(b, e)}
                        />{" "}
                        x
                        <input
                          name="signa2"
                          className="form-control form-control-sm col-md-1"
                          type="text"
                          placeholder="signa 2"
                          value={this.state.rekonsiliasi_obat[b]?.signa2}
                          onChange={(e) => this.onchangeRekonsilisasi(b, e)}
                        />
                        <button
                          className="btn btn-sm btn-primary col-md-1"
                          onClick={() =>
                            this.setState({
                              rekonsiliasi_obat:
                                this.state.rekonsiliasi_obat.concat([
                                  {
                                    name: "",
                                    signa1: "",
                                    signa2: "",
                                  },
                                ]),
                            })
                          }
                        >
                          +
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </>
              {/* // : '' */}
              {/* } */}
              <button className="btn btn-primary" type="submit">
                Simpan
              </button>
              <button className="btn btn-danger" onClick={this.onReload}>
                Tutup
              </button>
            </Form>
          )}
        </Formik>
      </>
    );
  }
}

export default Subjektif;
